// const actiDomain = "https://pgi.green4t.com/acti/apirest.php/"
// const zabbixDomain = "https://pgi.green4t.com/zabbix"

export const apiDomain = "/api";
export const actiDomain = `${apiDomain}/glpi/`;
export const zabbixDomain = "/zabbix";

export const DEVICE_UUID_HEADER = "X-Device-UUID";
